const LivePriceCategoryEnum = {
  CURRENCY       : 'Currency',
  COMMODITY      : 'Commodity',
  STOCK          : 'Stock',
  INTER_BANK_RATE: 'InterbankRate'
}

export default LivePriceCategoryEnum
